import styled from 'styled-components';
import { PInputText } from 'components/prime/PInputText/PInputText';
import { FormField } from 'components/FormField/FormField';
import { padding } from 'styles/styles';

export const TitleRenameFormStyle = {
  Form: styled.form`
    display: flex;
    align-items: flex-start;
    gap: 9px;
  `,
  FormField: styled(FormField)`
    flex: 1 1 auto;
    margin-bottom: ${padding.paddingXL};
  `,
  Input: styled(PInputText)`
    .p-inputtext {
      min-height: initial !important;
      height: 32px;
    }
  `,
  Actions: styled.div`
    flex: 0 0 fit-content;
    display: flex;
    align-items: center;
    gap: 8px;
  `,
};
